/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
export function ensureType(value) {
    return value;
}
export const ensureTypeExtends = () => (value) => {
    return value;
};
/* tslint:enable:max-line-length */
export function pipe(data, ...fns) {
    return pipeFromArray(fns)(data);
}
export function pipeFromArray(fns) {
    function noop() {
        return;
    }
    if (!fns) {
        return noop;
    }
    if (fns.length === 1) {
        return fns[0];
    }
    return function piped(input) {
        return fns.reduce((prev, fn) => fn(prev), input);
    };
}
export function pipeF(...fns) {
    return pipeFromArray(fns);
}
export function compose(...funcs) {
    if (funcs.length === 0) {
        return (arg) => arg;
    }
    if (funcs.length === 1) {
        return funcs[0];
    }
    return funcs.reduce((a, b) => (...args) => a(b(...args)));
}
export function iif(condition, ifTrue, ifFalse) {
    if (ifTrue && ifFalse) {
        return (data) => {
            return condition(data) ? ifTrue(data) : ifFalse(data);
        };
    }
    if (ifTrue) {
        return (data) => {
            return condition(data) ? ifTrue(data) : undefined;
        };
    }
    return (data) => {
        return condition(data) ? data : undefined;
    };
}
/**
 * Shapes data with new format and returns correct format
 */
export function shape(fn) {
    return fn;
}
/**
 * Runs the given function with the supplied object, then returns the object.
 * @note Good for login and debugging pipelines
 */
export function tap(fn) {
    return (data) => {
        // tslint:disable-next-line:no-expression-statement
        fn(data);
        return data;
    };
}
export function condition(...args) {
    return (data) => {
        for (const fn of args) {
            const r = fn(data);
            if (r) {
                return r;
            }
            continue;
        }
        return;
    };
}
/**
 * Caches function output
 */
export function cache(fn) {
    // eslint-disable-next-line prefer-const
    let memoizeCache = {};
    return (...args) => {
        if (memoizeCache[args]) {
            return memoizeCache[args];
        }
        const result = fn(...args);
        if (result instanceof Promise) {
            return result.then((q) => {
                return (memoizeCache[args] = q);
            });
        }
        memoizeCache[args] = result;
        return result;
    };
}
export function curry(fn) {
    const f = (curryFunc, length, arr) => (...args) => args.length < length ?
        f(curryFunc, length - args.length, arr.concat(args)) :
        curryFunc(...arr.concat(args));
    return f(fn, fn.length, []);
}
